<template>
  <span>
    <b-row class="mx-auto" style="width: 98%">
      <b-col col lg="12" md="12" sm="12">
        <v-stepper alt-labels size="12" v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1" color="#db0000">
              Customer Details
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2" color="#db0000">
              Box Details
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step color="#db0000" :complete="e1 > 3" step="3">
              Summary
            </v-stepper-step>
            <v-divider></v-divider>

            <v-stepper-step color="#db0000" step="4"> Receipt </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items style="background-color: #ffffff">
            <v-stepper-content step="1">
              <v-divider></v-divider><br />
              <customer-details
                v-on:goTo="nextTab"
                v-on:customerDetails="getCustomerDetails"
              ></customer-details>

              <!--<v-btn color="primary" @click="e1 = 2"> Next </v-btn>

              <v-btn text> Cancel </v-btn>-->
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-divider></v-divider><br />
              <box-details
                v-on:goTo="nextTab"
                v-on:boxDetails="getBoxDetails"
              ></box-details>
              <!-- <v-btn color="primary" @click="e1 = 3"> Next </v-btn>

              <v-btn text> Cancel </v-btn>-->
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-divider></v-divider><br />
              <BoxSummary
                :customerDetails="customerDetails"
                :boxDetails="boxDetails"
                v-on:goTo="nextTab"
                v-on:boxSummaryData="getBoxSummaryData"
              ></BoxSummary>
              <br />

              <!-- <v-btn color="primary" @click="e1 = 4"> Next </v-btn>

              <v-btn text> Cancel </v-btn>-->
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-divider></v-divider><br />
              <receipt :boxSummaryData="boxSummaryData"></receipt>
              <br />
              <!--<v-btn class="primary" @click="alert('Precessing receipt')">
                Finish
              </v-btn>

              <v-btn text> Cancel </v-btn>-->
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </b-col>
    </b-row>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CustomerDetails from "@/views/dashboard/apply-box/CustomerDetails";
import BoxDetails from "@/views/dashboard/apply-box/BoxDetails";
import Receipt from "@/views/dashboard/apply-box/Receipt";
import BoxSummary from "@/views/dashboard/apply-box/BoxSummary";

export default {
  name: "PayArrears",
  components: { BoxSummary, Receipt, BoxDetails, CustomerDetails },
  data() {
    return {
      e1: 1,
      payArrearsSpinner: false,
      form: {
        customer_type: null,
        category: null,
        name: null,
        id_type: null,
        nationality: null,
        occupation: null,
        director1: null,
        director2: null,
        contact1: null,
        contact2: null,
        email: null,
      },
      station: [
        { value: null, text: "Select Station" },
        { value: "Jinja", text: "Jinja" },
        { value: "Kampala", text: "Kampala" },
        { value: "Masaka", text: "Masaka" },
        { value: "Kamuli", text: "Kamuli" },
      ],
      customer_type: [
        { value: null, text: "Select Customer Type" },
        { value: "individual", text: "Individual" },
        { value: "ngo", text: "None Government Organization (NGO)" },
      ],
      category: [
        { value: null, text: "Select Category" },
        { value: "wholesalers", text: "Wholesalers" },
        { value: "limited", text: "Limited" },
      ],
      id_type_item: [
        { value: null, text: "Select Id Type" },
        { value: "wholesalers", text: "National Id" },
        { value: "limited", text: "Driving Licence" },
      ],
      nationality_item: [
        { value: null, text: "Select Nationality" },
        { value: "1232", text: "Ugandan" },
        { value: "23456", text: "Kenyan" },
      ],
      customerDetails: null,
      boxDetails: null,
      boxSummaryData: null,
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["getOrders", "getClientId", "getTracking"]),
  },
  watch: {},
  methods: {
    ...mapActions(["makeTrackingRequest"]),
    renewBox(env) {
      env.preventDefault();
      alert(JSON.stringify(this.form));
    },
    nextTab(tab) {
      this.e1 = tab;
    },
    getCustomerDetails(customerDetails) {
      this.customerDetails = customerDetails;
    },
    getBoxDetails(boxDetails) {
      this.boxDetails = boxDetails;
    },
    getBoxSummaryData(boxSummaryData) {
      this.boxSummaryData = boxSummaryData;
    },
  },
};
</script>

<style scoped>
@import "../../commons/tables.css";

.delivery {
  width: 100%;
}

.action {
  margin-top: 30px;
  margin-left: 20px;
}

.button {
  background: #db0000;
  border: none;
  border-radius: 2px;
  color: #fff;
  padding: 8px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}

.button:hover {
  background: #9f0012;
}

.input {
  width: 100%;
  margin-bottom: 10px;
}

.form {
  width: 100%;
  margin: 15px;
}

.results {
  width: 90%;
  margin-top: 10px;
  margin-left: 20px;
}

.key-label {
  color: #222222;
  font-size: 14px;
  font-weight: bold;
}

.label {
  color: #222222;
  font-size: 14px;
}

.signUpButtonCard {
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  margin-top: 4%;
}

.input-text-wrapper {
  border: #ced4da 1px solid;
  padding: 3px;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 8px;
}

.box-text-input {
  border: none;
  font-size: 13px;
  height: 13vm;
  color: #8898aa;
  outline: none;
  box-shadow: none !important;
}

.status {
  font-size: 14px;
  background: #0a7027;
  color: white;
  padding: 4px 8px;
  border-radius: 3px;
  margin-left: 1px;
  font-weight: bold;
  text-align: center;
}
</style>
